import { render, staticRenderFns } from "./NewExcelFile.vue?vue&type=template&id=33436652&"
import script from "./NewExcelFile.vue?vue&type=script&lang=js&"
export * from "./NewExcelFile.vue?vue&type=script&lang=js&"
import style0 from "./NewExcelFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports